var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgReplay = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "live_tv_black_24dp",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_70740",
    "data-name": "Path 70740",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70741",
    "data-name": "Path 70741",
    d: "M21,6H13.41l2.94-2.94a.5.5,0,0,0-.71-.71L12,5.99,8.36,2.35a.5.5,0,0,0-.71.71L10.59,6H3A2,2,0,0,0,1,8V20a2.006,2.006,0,0,0,2,2H21a2.006,2.006,0,0,0,2-2V8A2,2,0,0,0,21,6ZM20,20H4a1,1,0,0,1-1-1V9A1,1,0,0,1,4,8H20a1,1,0,0,1,1,1V19A1,1,0,0,1,20,20Z",
    fill: "#505c7c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "replay-24px",
    d: "M6.808,2.845V1.882a.171.171,0,0,0-.293-.121L5.2,3.069a.171.171,0,0,0,0,.245L6.511,4.622a.175.175,0,0,0,.3-.124V3.535A2.071,2.071,0,1,1,4.758,5.9a.345.345,0,0,0-.683.1A2.764,2.764,0,1,0,6.808,2.845Z",
    transform: "translate(5.179 8.928)",
    fill: "#505c7c"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReplay, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/replay.e86f9a19.svg";
export { ForwardRef as ReactComponent };